import { render, staticRenderFns } from "./PublicShareAuthRequestPasswordButton.vue?vue&type=template&id=42d780fa&scoped=true&"
import script from "./PublicShareAuthRequestPasswordButton.vue?vue&type=script&lang=js&"
export * from "./PublicShareAuthRequestPasswordButton.vue?vue&type=script&lang=js&"
import style0 from "./PublicShareAuthRequestPasswordButton.vue?vue&type=style&index=0&id=42d780fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d780fa",
  null
  
)

export default component.exports